import React, { FC } from 'react';
import '../App.css';
const Home: FC = () => {
    return (
        <div className="home">
                
                <div className="home-content">
                    <h1>IIT Kanpur HV Laboratory</h1>
                    <p>Empowering Innovation, Energizing the Future.</p>

                    <button>GET TO KNOW MORE</button>
                    
                </div>
                
      </div>
    );
};

export default Home;